// extracted by mini-css-extract-plugin
module.exports = {"formControl":"AddDeviceGroupInputModalForm_component_formControl__3kCX9","box":"AddDeviceGroupInputModalForm_component_box__2pCFG"};